import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../state/AuthContext";
import { ClientContext } from "../../state/ClientContext";

export default function ClientReferences() {
  const navigate = useNavigate();
  const { selectedClient, changeSelectedClient, changeSelectedCaregiver } =
    useContext(ClientContext);

  const { currentUser } = useContext(AuthContext);

  const caregivers = useMemo(() => {
    if (!selectedClient) {return [];}

    const refs = selectedClient.caregivers ?? [];

    // Sort by last name (handle both snake_case and camelCase)
    const sorted = [...refs].sort((a, b) => {
      const aLastName = a?.lastName || a?.last_name || "";
      const bLastName = b?.lastName || b?.last_name || "";
      return aLastName.localeCompare(bLastName);
    });

    // Drop nullish entries once, before branching. The sort above already
    // guards `a?.lastName`, so this list is known to be able to contain holes —
    // and the render below reads `cg.id` and `cg.name` unguarded, so a hole
    // that survives to that point crashes the section regardless of which
    // branch produced it.
    const present = sorted.filter(Boolean);

    if (currentUser?.isSuperAdmin || currentUser?.isAdmin) {
      return present;
    }

    // This filter exists to hide the viewer from their own caregiver list.
    // With no known viewer there is nobody to hide, so show the full list —
    // dereferencing `currentUser.id` here crashed the whole section in
    // production while AuthContext was still resolving.
    if (!currentUser) {
      return present;
    }

    return present.filter((ref) => ref.id !== currentUser.id);
  }, [selectedClient, currentUser]);

  if (!selectedClient) {return null;}

  return (
    <div
      className="client-profile-section"
      style={{
        backgroundColor: "#D9D9D9",
        padding: "16px",
        marginBottom: "40px",
      }}
    >
      <h1 style={{ textAlign: "left", fontWeight: "800" }}>
        {currentUser?.isSuperAdmin || currentUser?.isAdmin
          ? `Client's caregivers`
          : `Other caregivers assigned to this client`}
      </h1>

      {(currentUser?.isSuperAdmin || currentUser?.isAdmin) && (
        <p>
          {caregivers.length === 0 ? (
            <span>
              This client isn’t assigned to any caregivers. Need to change that?
            </span>
          ) : (
            <span>Need to change the caregivers assigned to this client?</span>
          )}
          <a
            href="#"
            onClick={(ev) => {
              ev.preventDefault();
              navigate("/assignment_center");
            }}
            style={{ marginLeft: "6px" }}
          >
            Go to assignment center
          </a>
        </p>
      )}

      {!currentUser?.isSuperAdmin &&
        !currentUser?.isAdmin &&
        caregivers.length === 0 && (
        <p>No other caregivers assigned to this client.</p>
      )}

      {caregivers.length > 0 && (
        <table>
          <tbody>
            {caregivers.map((cg) => (
              <tr key={cg.id}>
                <td>{cg.name}</td>
                <td>
                  <a
                    href="#"
                    onClick={(ev) => {
                      ev.preventDefault();
                      changeSelectedClient(null);
                      changeSelectedCaregiver(cg.id);
                      navigate(`/caregiver_profile/${cg.id}`, {
                        state: { user: cg },
                      });
                    }}
                  >
                    Go to caregiver
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
